export const reduxKey = '@@boostCoreModal';
export const actionKey = '@@boostCoreModal';
